<template>
  <div>

    <div class="row mt-4 mb-4">
      <div class="col-md-8">
        <input v-model="nextGeneric" type="search" class="input form-control"
               placeholder="Pesquisar por nome">
      </div>

      <div class="col-md-1">
        <button v-show="nextGeneric" class="btn btn-link nowrap" @click="clearFilter()">
          Limpar filtro
        </button>
      </div>

      <div class="col-md-3">
        <button class="btn btn-outline btn-xl float-right">
          Exportar
        </button>
      </div>
    </div>

    <table class="table table-borderless table-border table-align table-h51">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Produto</th>
          <th>Serviço</th>
          <th>Esfera</th>
          <th>Status</th>
          <th>Última atualização</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="service in scrapingServices" :key="service.id">
          <td>{{ service.friendly_name }}</td>
          <td>{{ service.app_name }}</td>
          <td>{{ filterExecutor(service.executor) }}</td>
          <td v-if="service.enable" style="color: green"><b>Ativo</b></td>
          <td v-else class="bold" style="color: red"> Inativo </td>
          <td style="text-transform: capitalize">{{ (service.sphere) }}</td>
          <td> {{ service.updated_at | datetime }} </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

export default {
  name: 'ScrapingServiceTable',
  data() {
    return {
      scrapingServices: [],
      lines: [],
      page: 1,
      perPage: 10,
      nextGeneric: '',
    }
  },
  created() {
    this.fetchScrapingServices()
  },
  methods: {
    fetchScrapingServices() {
      const params = {
        meta: false,
        per_page: 1000,
      }
      return this.axios.get('maestro/scraping_services', { params })
          .then(response => this.scrapingServices = response.data)
          .then(() => this.scrapingServices.sort((a, b) => a.friendly_name.localeCompare(b.friendly_name)))
          .catch(e => this.$notify.addError(e))
    },
    clearFilter() {
      this.nextGeneric = ''
    },
    filterExecutor(executor) {
      if (executor === 'Infosimples') {
        return 'I.S.'
      } else {
        return executor
      }
    },
  },
}

</script>

<style>

</style>